<template>
    <div class="container">
        <div class="row mx-auto px-2 mb-4">
            <div class="col-lg-1 d-none d-lg-flex flex-column p-0">
                <div v-for="(img, index) of product.img" :key="index" :class="{'p-2': index==show}">
                    <img :src="img" class="img-fluid rounded my-1" style="cursor:pointer;" @click="show=index">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="carousel slide carousel-fade rounded" data-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item" :class="{active: index == show}" v-for="(img, index) of product.img" :key="index">
                            <img :src="img" class="d-block w-100">
                        </div>
                    </div>
                    <a class="carousel-control-prev control" @click="changePic(-1)">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </a>
                    <a class="carousel-control-next control" @click="changePic(1)">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </a>
                </div>
            </div>
            <div class="col-lg">
                <h2>{{product.name}}</h2>
                <Categories :categories="product.categories" />
                <div class="">
                    <div class="col">
                        Cantidad:
                    </div>
                    <select class="form-select" v-model="pack">
                        <option :value="index" v-for="(price, index) of product.prices" :key="index">{{price.quantity}} por ${{price.price}}</option>
                    </select>
                </div>
                <div class="d-grid gap-2 mt-2">
                    <button @click="addToCart" class="btn btn-success" type="button">Agregar al carrito <i class="fas fa-cart-plus"></i></button>
                </div>
            </div>
        </div>
        <div class="mb-2">
            <h4 class="mb-3">Otros productos que pueden interesarte:</h4>
            <div class="row mx-center">
                <ProductHorizontal :product="product" :key="index" v-for="(product, index) of filterProducts()" />
            </div>
        </div>
    </div>
</template>

<script>
import Categories from '../components/Categories';
import ProductHorizontal from '../components/ProductHorizontal';

export default {
    name: 'Catalog',
    components:{
        ProductHorizontal,
        Categories
    },
    props:['catalog'],
    data(){
        var product = this.catalog.find(p => p.id == this.$route.params.id);
        var show = product.defaultImg;
        var pack = 0;
        return {
            product,
            show,
            pack
        }
    },
    methods:{
        filterProducts(){
            return this.catalog.filter(p => p.id!=this.product.id && this.product.categories.some(c => p.categories.includes(c)));
        },
        addToCart(){
            this.$emit('addToCart', this.product.id, this.pack, 1);
        },
        changePic(count){
            this.show += count;
            if(this.show < 0) this.show = this.product.img.length-1
            else if(this.show >= this.product.img.length) this.show = 0 
        }
    },
}
</script>

<style lang="scss" scoped>
.carousel{
    overflow: hidden;
}
.control{
    cursor:pointer;
    color: white;
    &.carousel-control-prev{
        background: linear-gradient(to right, rgba(0,0,0,0.5), rgba(0,0,0,0));
    }
    &.carousel-control-next{
        background: linear-gradient(to left, rgba(0,0,0,0.5), rgba(0,0,0,0));
    }
}
</style>